export default function useSourceFlowCollection(data, mappings = null) {
  let collection = Array.isArray(data) ? data : [];

  if (!mappings) return collection;

  const keys = Object.keys(mappings);

  return collection.map((item) => {
    keys.forEach((key) => {
      if (key in item && item[key] !== null) {
        const relatedItems = Array.isArray(mappings[key]) ? mappings[key] : [];
        item[`__${key}`] = item[key];
        item[key] = Array.isArray(item[key])
          ? relatedItems.filter((m) => item[key].includes(m.id))
          : relatedItems.find((m) => item[key].includes(m.id)) ?? null;
      }
    });
    return item;
  });
}
